import { Injectable } from '@angular/core';
import firebase from 'firebase';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../environment/environment';

import { InvestorModel, InvestorFormModel } from "../models/investor.model";
import { CompanyListModel, CompanyDetails } from '../models/company.model';
import { ProfileModel } from '../models/profile.model';

@Injectable()
export class InvestorService {

  companyDetailsRef = firebase.database().ref('/companyDetails');
  backendURL = environment.backendURL;

  constructor(
    private http: HttpClient
  ) { }

  async getAllCompaniesForListInvestor(investmentReadyCompanyList: Array<InvestorModel>, values: any): Promise<Array<CompanyListModel>> {
    let companyList = new Array<CompanyListModel>();
    values.downPayment = +(values.downPayment);

    return new Promise<Array<CompanyListModel>>(async (resolve, reject) => {

      for (let i = 0; i < investmentReadyCompanyList.length; i++) {
        let element = investmentReadyCompanyList[i];

        if (element.companyCategory !== values.companyCategory) continue;
        if (values.period && element.employeePeriod !== values.period) continue;
        if (values.categorizedAs && element.categorizedAs !== values.categorizedAs) continue;
        if (values.downPayment && element.downPayment !== values.downPayment) continue;
        if (values.financeType && element.investmentType.indexOf(values.financeType) < 0) continue;

        await this.companyDetailsRef.child(element.id)
          .once('value', snapshot => {

            if (snapshot.val()) {
              var temp = this.mapCompanyDetailsToList(snapshot.val());
              temp.investmentType = element.investmentType;
              temp.downPayment = element.downPayment;
              companyList.push(temp);
            }
          });
      }

      return resolve(companyList);
    });
  }

  async getAllCompaniesForInvestor(values: any): Promise<Array<CompanyListModel>> {

    return new Promise<Array<any>>(async (resolve, reject) => {

      await firebase.database().ref('/investments/companies')
        .orderByChild('city')
        .equalTo(values.city)
        .once('value', async snapshot => {

          if (snapshot.val()) {
            var investmentReadyCompanyList = Object.values(snapshot.val()) as Array<InvestorModel>;

            await this.getAllCompaniesForListInvestor(investmentReadyCompanyList, values).then(res => {

              return resolve(res);
            });

            return reject();
          } else {
            return reject();
          }
        }).catch(error => {
        });
    });
  }

  mapCompanyDetailsToList(element): CompanyListModel {
    let company = new CompanyListModel();
    company.description = element.description;
    company.id = element.id;
    if (element.images) {
      company.image = element.images[0];
    } else {
      company.image = environment.defaultImages.notAvailable;
    }
    company.name = element.title;
    company.followerCount = element.followerCount;
    company.category = element.category;
    company.subCategory = element.subCategory;
    company.type = element.type;
    company.worth = element.worth;
    company.categorizedAs = element.categorizedAs;
    company.city = element.city;

    return company;
  }

  getInvestmentCategories() {

    return new Promise((resolve, reject) => {
      firebase.database().ref('investments/categories').once('value', snapshot => {
        if (snapshot && snapshot.val()) {
          return resolve(snapshot.val());
        }

        return reject()
      }, error => {
        return reject(error);
      });
    });
  }

  async convertCurrency(to, from, amount): Promise<number> {

    let data = {
      to: to,
      from: from,
      amount: amount
    };

    let token;

    await firebase.auth().currentUser.getIdToken(true).then(idToken => {
      token = idToken;
    }).catch(error => {
      return Promise.reject(error);
    });

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };

    return new Promise<number>((resolve, reject) => {

      this.http.post((this.backendURL + 'convertCurrency'), data, httpOptions)
        .subscribe((res) => {

          if (res['result'] == 'success')
            return resolve(res['data']);
        })
    });
  }

  async publishInvestment(investorModel: InvestorFormModel, profile: ProfileModel, companyDetails: CompanyDetails): Promise<any> {
    return new Promise(async (resolve, reject) => {

      await firebase.database().ref('contracts/investments').child(investorModel.id).set(investorModel).then(res => {

        if (!profile.contractId || Object.values(profile.contractId).indexOf(investorModel.id) === -1)
          firebase.database().ref('users').child(investorModel.uid).child('contractId').push(investorModel.id);

        if (!companyDetails.contractId || Object.values(companyDetails.contractId).indexOf(investorModel.id) === -1)
          firebase.database().ref('companyDetails').child(investorModel.cid).child('contractId').push(investorModel.id);

        return resolve();
      }, error => {
        return reject(error);
      });
    });
  }

  async getContractDetails(contractId: Array<string>): Promise<Array<InvestorFormModel>> {

    try {
      return new Promise<Array<InvestorFormModel>>(async (resolve, reject) => {
        let list = Object.values(contractId);
        let contractsArr = new Array<InvestorFormModel>();

        await list.forEach(async element => {
          await firebase.database().ref('contracts/investments').child(element).once('value', async snapshot => {

            if (snapshot && snapshot.val()) {
              await contractsArr.push(snapshot.val());
            }
          });

        });

        return resolve(contractsArr);

      });
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateContractStatus(contract: InvestorFormModel) {
    contract.updatedOn = new Date().toDateString();
    contract.approvedOn = new Date().toDateString();

    try {

      return new Promise<any>(async (resolve, reject) => {

        await firebase.database().ref('contracts/investments').child(contract.id).update(contract).then(() => {
          return resolve();
        }, error => {
          return reject(error);
        });
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/investor.service.ts